import { render, staticRenderFns } from "./RegionalData.vue?vue&type=template&id=1c784b0b"
import script from "./RegionalData.vue?vue&type=script&lang=js"
export * from "./RegionalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports